import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import { DownloadRequestFragmentFragmentDoc } from '../../download-requests/__generated__/page.gql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RequestRegisterDownloadMutationVariables = Types.Exact<{
  input: Types.RequestRegisterDownloadInput;
}>;


export type RequestRegisterDownloadMutation = { readonly __typename?: 'Mutation', readonly requestRegisterDownload: { readonly __typename?: 'RegisterDownloadRequest', readonly id: string, readonly registerType: Types.RegisterType, readonly selectedColumns?: ReadonlyArray<string | null> | null, readonly clinic: { readonly __typename?: 'Clinic', readonly name: string }, readonly actor: { readonly __typename?: 'User', readonly person?: { readonly __typename?: 'UserPerson', readonly firstname?: string | null, readonly lastname?: string | null } | null }, readonly filters: { readonly __typename?: 'DownloadRegisterFilters', readonly startDate: string, readonly endDate: string }, readonly meta?: { readonly __typename?: 'Meta', readonly created?: string | null, readonly updated?: string | null } | null, readonly download?: { readonly __typename?: 'RegisterDownload', readonly id: string, readonly status: Types.RegisterDownloadStatus, readonly result?: { readonly __typename?: 'RegisterRecordDownload', readonly expiresAt?: string | null } | null } | null } };


export const RequestRegisterDownloadDocument = gql`
    mutation RequestRegisterDownload($input: RequestRegisterDownloadInput!) {
  requestRegisterDownload(input: $input) {
    ...DownloadRequestFragment
  }
}
    ${DownloadRequestFragmentFragmentDoc}`;
export type RequestRegisterDownloadMutationFn = Apollo.MutationFunction<RequestRegisterDownloadMutation, RequestRegisterDownloadMutationVariables>;

/**
 * __useRequestRegisterDownloadMutation__
 *
 * To run a mutation, you first call `useRequestRegisterDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestRegisterDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestRegisterDownloadMutation, { data, loading, error }] = useRequestRegisterDownloadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestRegisterDownloadMutation(baseOptions?: Apollo.MutationHookOptions<RequestRegisterDownloadMutation, RequestRegisterDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestRegisterDownloadMutation, RequestRegisterDownloadMutationVariables>(RequestRegisterDownloadDocument, options);
      }
export type RequestRegisterDownloadMutationHookResult = ReturnType<typeof useRequestRegisterDownloadMutation>;
export type RequestRegisterDownloadMutationResult = Apollo.MutationResult<RequestRegisterDownloadMutation>;
export type RequestRegisterDownloadMutationOptions = Apollo.BaseMutationOptions<RequestRegisterDownloadMutation, RequestRegisterDownloadMutationVariables>;